// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnBlue_my_btn__waLsK"};